import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=b4a87c26&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=ts&"
export * from "./Rule.vue?vue&type=script&lang=ts&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=b4a87c26&lang=stylus&scoped=true&"
import style1 from "./Rule.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a87c26",
  null
  
)

export default component.exports